import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { useState, useEffect } from "react";
import { Ionicons } from "@expo/vector-icons";
import Colors from "../../../Resources/Color";

/**
 * SelectionCard Component
 * A reusable card component for displaying selectable options with an icon and text
 */
export const SelectionCard = ({
  icon,
  text,
  isSelected = false,
  isHovered = false,
  onPress,
  onMouseEnter,
  onMouseLeave,
  animationDelay = 0,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, animationDelay);

    return () => clearTimeout(timer);
  }, [animationDelay]);

  return (
    <div
      style={{
        flex: 1,
        minWidth: 150,
        maxWidth: 200,
        opacity: isVisible ? 1 : 0,
        transform: `translateY(${isVisible ? 0 : 10}px)`,
        transition: "opacity 400ms ease-out, transform 400ms ease-out",
      }}
    >
      <TouchableOpacity
        style={[
          styles.card,
          isHovered && styles.cardHovered,
          isSelected && styles.cardSelected,
        ]}
        onPress={onPress}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <View style={styles.checkboxContainer}>
          <View
            style={[styles.checkbox, isSelected && styles.checkboxSelected]}
          >
            {isSelected && (
              <Ionicons name="checkmark" size={12} color={Colors.bubbleColor} />
            )}
          </View>
        </View>

        <View style={styles.iconContainer}>{icon}</View>

        <View
          style={{
            marginTop: 20,
            alignItems: "flex-start",
            justifyContent: "center",
            flex: 1,
          }}
        >
          <Text
            style={[styles.text, isSelected && styles.textSelected]}
            numberOfLines={3}
          >
            {text}
          </Text>
        </View>
      </TouchableOpacity>
    </div>
  );
};

const styles = StyleSheet.create({
  card: {
    flex: 1,
    minWidth: 150,
    maxWidth: 200,
    height: 100,
    paddingHorizontal: 16,
    paddingTop: 16,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    position: "relative",
    transitionProperty: "background-color, border-color",
    transitionDuration: "200ms",
    transitionTimingFunction: "ease-in-out",
  },
  cardHovered: {
    borderWidth: 1,
    borderColor: Colors.grayColor,
  },
  cardSelected: {
    backgroundColor: `${Colors.bubbleColor}10`,
    borderColor: Colors.bubbleColor,
  },
  checkboxContainer: {
    position: "absolute",
    top: 12,
    right: 12,
  },
  checkbox: {
    width: 16,
    height: 16,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    justifyContent: "center",
    alignItems: "center",
  },
  checkboxSelected: {
    backgroundColor: Colors.whiteColor,
    borderColor: Colors.bubbleColor,
  },
  iconContainer: {
    position: "absolute",
    top: 16,
    left: 16,
  },
  text: {
    fontSize: 14,
    fontWeight: "500",
    color: Colors.blackColor,
    // marginLeft: 16,
    // marginRight: 16,
  },
  textSelected: {
    // Can add specific selected text style if needed
  },
});

export default SelectionCard;
